import { RestClient } from "./restClient";

export class LradService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	getVolume(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/volume`;
		this._restClient.exec_get(url, callback);
	}

	setVolume(cameraId, volume, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/volume`;
		const body = JSON.stringify({ volume });
		this._restClient.exec_post(url, body, callback);
	}

	getBeamInfo(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/beam`;
		this._restClient.exec_get(url, callback);
	}

	setBeamOn(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/beam/beamOn`;
		this._restClient.exec_post(url, null, callback);
	}

	setBeamOff(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/beam/beamOff`;
		this._restClient.exec_post(url, null, callback);
	}

	setStrobeOn(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/beam/strobeOn`;
		this._restClient.exec_post(url, null, callback);
	}

	setStrobeOff(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/beam/strobeOff`;
		this._restClient.exec_post(url, null, callback);
	}

	getAudioFiles(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/audio/files`;
		this._restClient.exec_get(url, callback);
	}

	playAudio(cameraId, audioFile, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/audio/play`;
		const body = JSON.stringify({ audioFile });
		this._restClient.exec_post(url, body, callback);
	}

	stopAudio(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/audio/stop`;
		this._restClient.exec_post(url, null, callback);
	}

	getAudioPlayStatus(cameraId, callback) {
		const url = `/cameras-app/api/cameras/${cameraId}/audio/playStatus`;
		this._restClient.exec_get(url, callback);
	}
}
